import { render } from "./floating.vue?vue&type=template&id=3c7f48df"
import script from "./floating.vue?vue&type=script&lang=js"
export * from "./floating.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Code\\vue\\xypt-admin-wx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__